import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClientInputContent } from 'client/models';

@Component({
    selector: 'client-form-input-content-list',
    templateUrl: './client-form-input-content-list.component.html',
    styleUrls: ['client-form-input-content-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ClientFormInputContentListComponent implements OnInit {

  @Input() inputContents: ClientInputContent[] = [];
  @Input() formGroup!: FormGroup;

  constructor() { }

  ngOnInit() { }

}
